import { render } from "./iframePulldownDataConfiger.vue?vue&type=template&id=60e94d6b&scoped=true"
import script from "./iframePulldownDataConfiger.vue?vue&type=script&lang=js"
export * from "./iframePulldownDataConfiger.vue?vue&type=script&lang=js"

import "./iframePulldownDataConfiger.vue?vue&type=style&index=0&id=60e94d6b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e94d6b"]])

export default __exports__